import { VoltageSpeedDashboardSample } from '../../voltage-with-speed.models';
import { getSpeedVoltageCorrelation } from '../speed-voltage-scatter/speed-voltage-scatter.utils';
import { getTimelinePoints } from '../timeline/timeline.utils';

export function getCorrelationValue(samples: VoltageSpeedDashboardSample[], movingOnly: boolean): number | null {
  // shortcut: SampleType values are unknown; use sample-based Pearson until the server mapping is confirmed.
  const points = getTimelinePoints(samples).flatMap(point =>
    point.speed !== null && point.voltage !== null && (!movingOnly || point.speed > 0)
      ? [{ speed: point.speed, voltage: point.voltage, second: point.second }] : []);
  return getSpeedVoltageCorrelation(points);
}
